<template>
  <PullRefresh v-model="isLoading"
    success-text="刷新成功"
    @refresh="onRefresh"
  >
    <div :class="`${$style.vipPage} ${hiddenTitle ? $style.hiddenTitle : ''}`">
      <header>
        <div @click="closePage">
          <i class="iconfont yw-xiangzuo"></i>
        </div>
        <span>VIP权益中心</span>
      </header>
      <div :class="$style.gameBox">
        <div
          :class="$style.gameListMask"
          :style="{
            backgroundImage:
              `url(` + (gameList.length > 0 ? activeGame.icon : null) + `)`,
          }"
        ></div>
        <div :class="$style.gameList">
          <div
            v-for="(game) in gameList"
            :key="game.id"
            :class="`${$style.game} ${activeGame.gameId === game.gameId ? $style.activeGame : ''}`"
            @click="onChangeGame(game)"
          > 
            <img v-if="game.playing" :class="$style.playing" :src="`${cdnLink}/box_vip/playing.png`" loading="lazy"/>
            <img :src="game ? game.icon: ''" :class="$style.img" loading="lazy"/>
            <p :class="$style.gameTitle">{{ game.gameName }}</p>
          </div>
        </div>
      </div>
      <!-- 等级 -->
      <div :class="$style.level">
        <div :class="$style.titleBox">
          <p :class="$style.title">当前等级</p>
          <p v-if="uid" :class="$style.account" @click="accountVisible = true">账号：{{username}}<img :src="`${cdnLink}/box_vip/refresh.png`"/></p>
        </div>
        <div v-if="uid && vipType > -1" :class="$style.wrapper">
          <div :class="$style.bind">
            <div :class="$style.desc">{{vipText[vipType]}}</div>
            <Progress :percentage="percentage" color="linear-gradient(0deg,#ef4c5f 0%, #fd9a6f 72%)" track-color="#fff" stroke-width="7" />
            <div :class="$style.money">充值金额进度（元）{{vipAmount}}{{nextVipAmount ? '/' + nextVipAmount : null}}</div>
            <p :class="$style.tag" v-if="percentage !== 100">再充值{{nextVipAmount - vipAmount}}元可升级为{{vipText[vipType+1]}}</p>
          </div>
          <div :class="$style.vipBox">
            <img
              :src="`${cdnLink}/box_vip/vip_L${vipType+1}.png`"
              alt=""
              :class="$style.vipImg"
            />
            <span :class="$style.showDesc" @click="onHandleVipRule">查看VIP说明</span>
          </div>
        </div>
        <div v-else :class="$style.wrapper">
          <div :class="$style.unBind">
            <div :class="$style.desc">绑定账号查看当前VIP等级</div>
            <Button :class="$style.bindAccountBtn" @click="onOpenAccountDialog"
              >前往绑定</Button
            >
          </div>
          <div :class="$style.vipBox">
            <img
              :src="`${cdnLink}/box_vip/vip_default.png`"
              alt=""
              :class="$style.vipImg"
            />
            <span :class="$style.showDesc" @click="onHandleVipRule">查看VIP说明</span>
          </div>
        </div>

      </div>
      <div :class="$style.gameGift">
        <div :class="$style.headerBtn">
          <Button :class="$style.download" @click="onDownloadGame">下载游戏</Button>
          <Button :class="$style.vipServer" @click="onRelationCS(false)">联系VIP专属客服</Button>
        </div>
        <div :class="$style.title">
          <img :src="`${cdnLink}/box_vip/title.png`" alt="" />
          <p>VIP权益</p>
          <img
            :src="`${cdnLink}/box_vip/title.png`"
            alt=""
            :class="$style.titleImg"
          />
        </div>
        <div :class="$style.rightContainer">
          <div :class="$style.right" v-for="(item, index) in rightInfoManage" :key="item.id" @click="showRightInfo(index)">
            <img
              :src="item.icon"
              alt=""
              :class="$style.icon"
              :style="{
                filter: vipType !== item.type ? 'grayscale(1)' : null,
              }"
            />
            <p :class="$style.text">{{ item.name }}</p>
          </div>
        </div>
        <div v-if="rightInfo.length > 6" :class="$style.moreBtn" @click="isOpenRight = !isOpenRight">
          {{ isOpenRight ? '收起':'展开'}}<i :class="`iconfont  ${isOpenRight? 'yw-jiantou6': 'yw-jiantou9'} `" ></i>
        </div>

        <div :class="$style.title">
          <img :src="`${cdnLink}/box_vip/title.png`" alt="" />
          <p>VIP福利</p>
          <img
            :src="`${cdnLink}/box_vip/title.png`"
            alt=""
            :class="$style.titleImg"
          />
        </div>
        <Tabs
          v-model="activeTabsName"
          title-active-color="#eaa632"
          title-inactive-color="#999999"
          line-width="8"
          color="#864e1d"
          line-height="2"
          @change="onChangeTab"
        >
          <Tab title="VIP礼包" :title-class="$style.tabHeader" name="GIFT">
            <List v-model="vipGiftLoading"
            :finished="vipGiftFinished"
            finished-text="没有更多了"
            @load="onLoadGameGift"
            >
              <div :class="$style.tabContainer">
                <div
                  :class="`${$style.tabTitle}`"
                >
                  <img :src="activeGame.icon" loading="lazy"/>
                  <div>
                    <p :class="$style.name">{{ activeGame.gameName }}</p>
                    <p :class="$style.total">{{gameGiftData.total}}个礼包</p>
                  </div>
                </div>
                <div v-for="(gift, index) in gameGiftData.list" :key="gift.id" :class="$style.giftDetail">
                  <div>
                    <div :class="$style.name">
                      <div>{{gift.name}}</div>
                      <p>{{refreshText[index]}}</p>
                    </div>
                    <div :class="$style.detail">
                      <p>{{gift.content}}</p>
                    </div>
                  </div>
                  <button :class="gift.conditionType > vipType || gift.received ? $style.gray : '' " @click="onReceivedGift(gift)">
                  {{gift.received? '已':null}}领取
                  </button>
                </div>
              </div>
            </List>
          </Tab>
          <Tab title="VIP活动" :title-class="$style.tabHeader" name="ACTIVITY">
            <List v-model="vipActivityLoading"
            :finished="vipActivityFinished"
            finished-text="没有更多了"
            @load="onLoadGameActivity"
            >
              <div :class="$style.tabContainer">
                <div
                  :class="`${$style.tabTitle}`"
                >
                  <img :src="activeGame.icon" loading="lazy"/>
                  <div>
                    <p :class="$style.name">{{ activeGame.gameName }}</p>
                    <p :class="$style.total">{{gameActivityData.total || 0}}个活动</p>
                  </div>
                </div>
                <div 
                  v-for="(activity,index) in gameActivityData.list" 
                  :key="activity.id" 
                  :class="$style.activityDetail"
                  :style="{
                    backgroundImage:
                      `url(` + (activity.icon) + `)`,
                  }"
                  @click="onHandleActivity({...activity, btnText: gameActivityDataTime[index].btnText})"
                  >
                  <img :src="`${cdnLink}/box_vip/vipi_L${activity.conditionType + 1}.png`" alt="" :class="$style.vipIcon"/>
                  <div :class="$style.activityInfo">
                    <div :class="$style.time">活动时间：{{gameActivityDataTime[index].desc}}</div>
                    <span 
                    :class=" activity.conditionType > vipType || gameActivityDataTime[index].btnText !== '查看活动' ? $style.gray : '' "
                    >
                      {{gameActivityDataTime[index].btnText}}
                    </span>
                  </div>
                </div>
              </div>
            </List>
          </Tab>
        </Tabs>
      </div>

      <!-- 绑定角色弹窗 -->
      <transition name="fade">
        <div :class="$style.dialogMask" v-if="accountVisible">
          <div :class="$style.dialogContent">
            <h1>绑定账号</h1>
            <img
              :src="`${cdnLink}/box_sign/close.png`"
              alt=""
              :class="$style.close"
              @click="onCloseBind"
            />
            <div :class="$style.content" style="margin-top: 40px;">
              <p>账号:</p>
              <Field
                v-model.trim="accountForm.name"
                :class="$style.field"
              ></Field>
            </div>
            <div :class="$style.content">
              <p>密码:</p>
              <Field
                v-model.trim="accountForm.password"
                type="password"
                :class="$style.field"
              ></Field>
            </div>
            <Button :class="$style.nextStep" @click="onBindAccount">确认绑定</Button>
          </div> 
        </div>
      </transition>
      <!-- 礼包弹窗 -->
      <transition name="fade">
        <div :class="$style.dialogMask" v-show="giftVisible">
          <div :class="$style.dialogContent">
            <h1>领取提示</h1>
            <img
              :src="`${cdnLink}/box_sign/close.png`"
              alt=""
              :class="$style.close"
              @click="giftVisible = false"
            />
            <p :class="$style.giftDesc">复制以下口令发送至VIP专属客服 即可领取礼包</p>
            <div :class="`${$style.giftCode}`" >
              <p>口令</p>
              <p>账号：{{username}}</p>
              <p>游戏：{{activeGame.gameName}}</p>
              <p >{{curHandleGift.name}}</p>
            </div>
            <Button
              :data-clipboard-text="giftCode"
              :class="`${$style.giftBtn} copyCode`"
              @click="onCopyAndSkip"
              >复制口令并跳转VIP专属客服
            </Button>
          </div>
        </div>
      </transition>
      <!-- 权益介绍 -->
      <transition name="fade">
        <div :class="$style.dialogMask" v-if="rightInfoVisible">
          <div :class="$style.dialogContent">
            <h1>权益介绍</h1>
            <img
              :src="`${cdnLink}/box_sign/close.png`"
              alt=""
              :class="$style.close"
              @click="rightInfoVisible = false"
            />
            <Swipe @change="onChangeRightInfo" :loop="false" :width="310" ref="swipe" :initial-swipe="currentRightInfo" >
              <SwipeItem v-for="item in rightInfo" :key="item.id">
                <div :class="$style.swipe">
                  <div>
                    <p :class="$style.rightInfoTitle">{{item.name}}</p>
                    <p :class="$style.rule"
                      v-html="item ? item.introduction.replace(/(\r\n|\n|\r)/gm,'<br />'): '' "
                    >
                    </p>
                  </div>
                </div>
              </SwipeItem>
              <template #indicator>
                <div :class="$style.indicator">{{ currentRightInfo + 1 }}/{{rightInfo.length}}</div>
              </template>
            </Swipe>
            
          </div>
        </div>
      </transition>
    </div>
  </PullRefresh>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import { CDN_URL_1 } from "@/config";
import { onGoBack, setPageTitle } from "@/bridge/AppJsBridge";
import { burnPoint } from "@/apis/heziShare"; 
import { vipGameListApi, vipRightApi, vipGiftListApi, vipActivityListApi, bindUserApi, vipLevelApi, receiveGiftApi, getUserStatusApi } from "@/apis/vip";
import { Button, Field, Tab, Tabs, Swipe, SwipeItem, List, Progress, PullRefresh } from "vant";
import Clipboard from "clipboard";
import { getCookie, addParamsToken, checkIsWxBrowser, arraySort } from "@/libs/utils";
import moment from "moment";
const KEY = 'wx_box';

export default {
  name: "",
  components: { Button, Tab, Tabs, Swipe, SwipeItem, List, Field, Progress, PullRefresh},
  data() {
    return {
      gameList: [],
      cdnLink: CDN_URL_1,
      rightInfo: [],
      vipType: -1,
      vipAmount: 0,
      vipText: ['普通会员','普通VIP','至尊VIP'],
      rightInfoVisible: false,
      currentRightInfo: 0,
      activeGame: {gameId:null,icon:null,gameName:null},
      activeTabsName: "GIFT",
      vipGiftLoading: false,
      vipGiftFinished: true,
      gameGiftData:{
        list:[]
      },
      vipActivityLoading: false,
      vipActivityFinished: true,
      gameActivityData:{
        list:[]
      },
      accountVisible: false,
      accountForm: {
        name: "",
        password:''
      },
      uid: null,
      username: null,
      giftVisible: false,
      curHandleGift: {name: null},
      hiddenTitle: false,
      cookie:null, 
      isOpenRight: false,
      isLoading: false
    };
  },
  computed: {
    nextVipAmount: function(){
      let num = null
      if (this.vipType + 1 <  this.activeGame?.conditionList?.length) {
        num = this.activeGame.conditionList[this.vipType+1].minAmount
      }
      return num
    },
    rightInfoManage: function(){
      if (this.rightInfo.length > 6 && !this.isOpenRight) {
        return this.rightInfo.slice(0,6)
      }
      return this.rightInfo
    },
    refreshText: function(){
      const refresh = ['每日24点刷新','每周日24点刷新','每月1号刷新']
      let res = [];
      for (const item of this.gameGiftData.list) {
        res.push(refresh[item.refreshRate])
      }
      return res
    },
    gameActivityDataTime: function(){
      const time = [];
      const { list } = this.gameActivityData;
      let now = new Date().getTime();
      for (const item of list) {
        let start = moment(item.startTime).toArray();
        let end = item.endTime ? moment(item.endTime).toArray() : null;
        let desc = `${start[0]}年${start[1]+1}月${start[2]}日${start[3]}:${start[4]}`;
        if (end) {
          desc = desc + `-${end[0]}年${end[1]+1}月${end[2]}日${end[3]}:${end[4]}`
        }else{
          desc = '长期有效'
        }
        let btnText = '查看活动';
        if (now < new Date(item.startTime).getTime()) {
          // 活动尚未开始
          btnText = '敬请期待';
        }
        if (item.endTime && now > new Date(item.endTime).getTime()) {
          // 活动已经结束
          btnText = '已结束';
        }
        time.push({
          desc,btnText
        });
      }
      return time
    },
    giftCode: function(){
      return `账号：${this.username} 游戏：${this.activeGame.gameName} 礼包：${this.curHandleGift.name}`
    },
    percentage: function(){
      let percentage = 0;
      if (this.vipAmount>0) {
        percentage = this.vipAmount/this.nextVipAmount
      }
      percentage = percentage * 100 > 100 ? 100 : percentage * 100
      return percentage
    }
  },
  created() {
    // document.cookie = 'params={"androidid":"c1064486a6fe3139","appid":"200010949","bundleid":"com.hzwx.wx.box","channelId":"null","deviceId":"215901CF62ED4AA6B00B404AE09075369f54e6a276807a7628f847e895c2026e","deviceName":"OPPO PCHM10","devicetype":"PCHM10","imei":"null","inip":"172.16.56.26","mac":"null","network":"WIFI","oaid":"215901CF62ED4AA6B00B404AE09075369f54e6a276807a7628f847e895c2026e","op":"null","os":"android","osversion":"11","registerTime":0,"systemVersion":"11","userId":"220027972","uuid":"ffffffff-c928-5408-ffff-ffffc9285408"};'
    // document.cookie = 'token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NjE0MDY2NDc4ODQsImlhdCI6MTY2MDgwMTg0Nzg4NCwianRpIjoiMjZjZTVjNjctOTE4Zi00MjA5LWE4N2EtMmIwOWViOTM2MzE0Iiwic3ViIjoiQlTnm5LlrZAiLCJ1aWQiOjIyMDAyNzk3Mn0.VEbQc6yDj-zZMjDPQloS20wIJN2d4hZcFjMboFRYZxU'
    // this.documentCookie = document.cookie;
    // 页面初始化
    inithandler();
    setPageTitle('VIP权益中心');
    this.initPageData();

  },
  activated(){
    setPageTitle('VIP权益中心');
  },
  mounted() {
    this.copy = new Clipboard('.copyCode');
  },
  methods: {
    // 打开绑定账号弹窗
    onOpenAccountDialog(){
      // 数据上报：8.前往绑定
      this.eventTrack({
        event: 'vip_goto_bind',
        event_field:JSON.stringify({ is_play: this.activeGame.playing ? 1 : 0}),
        appName: this.activeGame.gameName,
        appkey: this.activeGame.gameId
      });
      this.accountVisible = true
    },
    // 判断是否需要隐藏标题拦
    checkHasPageTitle(){
      if (checkIsWxBrowser()) {
        this.hiddenTitle = true;
      }
      if (this.cookie) {
        this.hiddenTitle = true;
      }
    },

    // 获取cookie、缓存等携带的用户信息数据
    async initPageData(){
      const pageCookie = getCookie();
      const token = getCookie('token');
      if (token) {
        localStorage.setItem("token", token);
      }
      if (pageCookie) {
        for (const key in pageCookie) {
          if (Object.hasOwnProperty.call(pageCookie, key) && pageCookie[key] === 'null') {
            delete pageCookie[key]
          }
        }
        const { userId } = pageCookie;
        this.cookie = pageCookie;
        if (userId ) {
          this.uid = userId;
          // 数据上报：0.进入页面
          // this.eventTrack({event: 'vip_page'});
          // 请求用户状态
          this.getUserName();
        }else{
          await this.getUidStorage();
        }
      }else{
        await this.getUidStorage();
      }
      
      this.checkHasPageTitle();
      // 获取游戏列表
      this.getGameList();
      this.getGameRights();
    },
    // 获取用户状态
    getUserName(){
      getUserStatusApi().then(res => {
        const { userName = '' } = res.data;
        this.username = userName;
        window.localStorage.setItem('vip.info', JSON.stringify({
          uid: this.uid,
          username: userName
        }))
      })
    },
    // 获取缓存
    async getUidStorage(){
      let info = window.localStorage.getItem('vip.info');
      if (info) {
        this.uid = JSON.parse(info).uid;
        this.username = JSON.parse(info).username;
        // 数据上报：0.进入页面
        // this.eventTrack({event: 'vip_page', userId: this.uid});
      }
      
    },
    
    // 查询vip等级
    onGetVipType(){
      let {params, token} = addParamsToken({uid: this.uid, gameId: this.activeGame.gameId},KEY)
      if (!params.uid) {
        delete params.uid;
        this.vipGiftFinished = false;
        return
      }
      vipLevelApi({params, token}).then(res => {
        const { amount, type } = res.data;
        this.vipType = type;
        this.vipAmount = amount;

        this.vipGiftFinished = false;
        // this.vipActivityFinished = false;
      })
    },

    // 数据上报
    eventTrack(data) {
      burnPoint({
        ...this.cookie,
        ...data,
      }).catch(err => console.log(err));
    },

    // 领取礼包
    onCopyAndSkip() {
      // 数据上报：9.复制口令
      this.eventTrack({
        event: 'vip_pop_copy_code',
        userId: this.uid, 
        event_field: JSON.stringify({is_play:this.activeGame.playing ? 1 : 0,gift_id: this.curHandleGift.id,gift_name: this.curHandleGift.name}),
        appName: this.activeGame.gameName,
        appkey: this.activeGame.gameId
      });
      
      console.log("🚀 ~ file: vipPrivilegeCenter.vue ~ line 532 ~ onCopyAndSkip ~ copy", this.copy)
      this.copy.on("success", () => {
        this.$toast("复制成功");
      });
      this.copy.on("error", (e) => {
        this.$toast("复制错误",e);
      });
      setTimeout(() => {
        this.onRelationCS(true);
      }, 1000);
    },

    // 绑定账号
    onBindAccount(){
      // 数据上报：7.绑定账号
      this.eventTrack({
        event: 'vip_pop_sure_bind',
        userId: this.uid
      });

      let obj = {
        ...this.accountForm
      }
      let {params, token} = addParamsToken(obj,KEY)
      bindUserApi({params, token}).then(res => {
        const { data } = res;
        this.uid = data.uid;
        this.username = this.accountForm.name;
        window.localStorage.setItem('vip.info', JSON.stringify({
          uid: data.uid,
          username:this.accountForm.name
        }))
        this.$toast("账号绑定成功");
        this.onCloseBind();
        this.getGameList();

      })
    },

    // 取消绑定
    onCloseBind(){
      this.accountVisible = false;
      this.accountForm = {
        name: "",
        password:''
      }
    },

    // 切换游戏
    onChangeGame(game){
      this.activeGame = game;
      this.activeTabsName = 'GIFT';
      this.onGetVipType();
      // 数据上报：1.游戏切换
      this.eventTrack({
        event: 'vip_game_icons',
        event_field:JSON.stringify({ is_play: game.playing ? 1 : 0}),
        userId: this.uid, 
        appName: game.gameName,
        appkey: game.gameId
      })
    },

    // 权益列表
    getGameRights(){
      vipRightApi().then(res => {
        const {data = []} = res;
        this.rightInfo = [...data]
      })
    },

    // 游戏列表
    async getGameList() {
      let {params, token} = addParamsToken({uid: this.uid},KEY)
      if (!params.uid) {
        delete params.uid
      }
      const r = await vipGameListApi({token, ...params});
      // 数据上报：0.进入页面
      this.activeGame = r?.data[0];
      this.uid && this.eventTrack({event: 'vip_page', userId: this.uid, appkey:this.activeGame.gameId, appName:this.activeGame.gameName});
      this.gameList = r.data.map((item) => {
        return {
          ...item,
          text: item.appName,
          value: item.appkey,
        };
      });
      
      this.onGetVipType();

    },
    
    // 切换权益介绍
    onChangeRightInfo(index){
      this.currentRightInfo = index;
    },

    // 展示权益介绍弹窗
    showRightInfo(index) {
      // 数据上报：4.点击权益
      this.eventTrack({
        event: 'vip_legal_right',
        userId: this.uid, 
        event_field: JSON.stringify({legal_right_name: this.rightInfo[index].name})
      });

      this.rightInfoVisible = true;
      this.currentRightInfo = index;
      setTimeout(() => {
        this.$refs.swipe.resize();
      }, 500);
    },

    // 获取礼包列表
    getGameGiftList(data){
      const {page= 1,size = 20,gameId = this.activeGame.gameId} = data;
      let {params, token} = addParamsToken({page,size,gameId, uid: this.uid}, KEY)
      if (!params.uid) {
        delete params.uid
      }
      vipGiftListApi({...params,token}).then(res => {
        if (res?.data) {
          this.gameGiftData = this.sortGiftList(res.data);
        }
        this.vipGiftLoading = false;
        this.vipGiftFinished = true;
      })
    },

    // 礼包列表排序
    sortGiftList(data){
      const { list } = data;
      let PENDING = []; // 待领取
      let UNABLE = []; // 无法领取
      let RECEIVED = []; // 已领取
      for (const gift of list) {
        if ( gift.conditionType > this.vipType ) {
          // 不满足领取条件
          UNABLE.push(gift);
        }else{
          if (gift.received) {
            // 已领取
            RECEIVED.push(gift);
          }else{
            // 待领取
            PENDING.push(gift);
          }
        }
      }
      PENDING = arraySort(PENDING, 'sort');
      UNABLE = arraySort(UNABLE, 'sort');
      RECEIVED = arraySort(RECEIVED, 'sort');
      return {...data, list:[...PENDING, ...UNABLE, ...RECEIVED]}
    },

    // 获取活动列表
    getGameActivityList(params){
      const {page= 1,size = 20,gameId = this.activeGame.gameId} = params;
      vipActivityListApi({page, size, gameId}).then(res => {
        if (res?.data) {
          this.gameActivityData = this.sortActivityList(res.data);
        }
        this.vipActivityLoading = false;
        this.vipActivityFinished = true;
      })
    },

    // 礼包列表排序
    sortActivityList(data){
      const { list } = data;
      let PENDING = []; // 可查看
      let UNABLE = []; // 无法查看
      let UNSTART = []; // 敬请期待
      let END = []; // 已结束
      let now = new Date().getTime();
      for (const activity of list) {
        const {startTime, endTime} = activity;
        if (now < new Date(startTime).getTime()) {
          // 敬请期待
          UNSTART.push(activity);
        }

        if (endTime &&  now > new Date(endTime).getTime()) {
          // 已结束
          END.push(activity);
        }

        if (now >= new Date(startTime).getTime()) {
          if (!endTime || now <= new Date(endTime).getTime()) {
            if ( activity.conditionType > this.vipType ) {
              // 无法查看
              UNABLE.push(activity);
            }else{
              // 可查看
              PENDING.push(activity)
            }
          }
        }
        
      }
      PENDING = arraySort(PENDING, 'sort');
      UNABLE = arraySort(UNABLE, 'sort');
      UNSTART = arraySort(UNSTART, 'sort');
      END = arraySort(END, 'sort');

      return {...data, list:[...PENDING, ...UNABLE, ...UNSTART, ...END]}
    },

    // 加载
    onLoadGameGift(){
      let params = {
        page: this.gameGiftData?.currentPage || 1,
      }
      this.getGameGiftList(params);
    },
    onLoadGameActivity(){
      let params = {
        page: this.gameActivityData?.currentPage || 1,
      }
      this.getGameActivityList(params);
    },

    // 切换tab
    onChangeTab(name){
      if (name=== 'GIFT') {
        // this.gameGiftData = { list:[] };
        this.vipGiftFinished = false;
      }else{
        // this.gameActivityData = { list:[] }
        this.vipActivityFinished = false;
      }
    },

    // 领取礼包
    onReceivedGift(data){
      // this.curHandleGift = data;
      // this.giftVisible = true;

      // VIP等级不足
      if (data.conditionType > this.vipType) {
        this.$toast(`VIP等级不足，达到${this.vipText[data.conditionType]}可领取`);
        return
      }
      if (data.received) {
        this.$toast(`礼包已领取，请关注礼包刷新时间`);
        return
      }

      // 数据上报：5.领取礼包
      this.eventTrack({
        event: 'vip_gift_get',
        userId: this.uid, 
        event_field: JSON.stringify({is_play:this.activeGame.playing ? 1 : 0,gift_id: data.id,gift_name: data.name}),
        appName: this.activeGame.gameName,
        appkey: this.activeGame.gameId
      });

      let {params, token} = addParamsToken({uid: this.uid, giftId: data.id},KEY)
      if (!params.uid) {
        delete params.uid
      }
      receiveGiftApi({params, token}).then(res => {
        this.curHandleGift = data;
        this.giftVisible = true;
        this.vipGiftFinished = false;
      })
    },

    // 活动详情
    onHandleActivity(data){
      if (data.btnText === '敬请期待') {
        this.$toast('活动未开始，请持续关注活动时间');
        return
      }
      if (data.btnText === '已结束') {
        this.$toast('当前活动已结束');
        return
      }
      if (data.conditionType > this.vipType) {
        this.$toast(`VIP等级不足，达到${this.vipText[data.conditionType]}可查看活动`);
        return
      }

      // 数据上报：6.查看活动
      this.eventTrack({
        event: 'vip_active_scan',
        userId: this.uid, 
        event_field: JSON.stringify({is_play:this.activeGame.playing ? 1 : 0,active_id: data.id,active_name: data.name}),
        appName: this.activeGame.gameName,
        appkey: this.activeGame.gameId
      });
      
      this.$router.push({
        name: "box.detail", 
        params: {
          content: data.content,
          title:'VIP活动详情',
          cookie: this.cookie
          }
      });
    },

    // 规则详情
    onHandleVipRule(){
      this.$router.push({
        name: "box.detail", 
        params: {
          content: this.activeGame?.introduction || '',
          title:'VIP规则说明',
          cookie: this.cookie
          }
      });
    },

    // 下载游戏
    onDownloadGame(){
      // 数据上报：2.下载游戏
      this.eventTrack({
        event: 'vip_game_download',
        event_field:JSON.stringify({ is_play: this.activeGame.playing ? 1 : 0}),
        userId: this.uid, 
        appName: this.activeGame.gameName,
        appkey: this.activeGame.gameId
      });

      window.open(
        this.activeGame.downloadUrl,
        "_blank"
      );
    },

    // 联系客服
    onRelationCS(isBind = false){
      if (!isBind) {
        // 数据上报：3.联系客服
        this.eventTrack({
          event: 'vip_linkme',
          event_field:JSON.stringify({ is_play: this.activeGame.playing ? 1 : 0}),
          userId: this.uid, 
          appName: this.activeGame.gameName,
          appkey: this.activeGame.gameId
        });
        if (this.uid && this.vipType < 1) {
          this.$toast(`VIP等级不足`);
          return;
        }
        if (!this.uid && this.vipType < 1) {
          this.accountVisible = true
          return;
        }
      }
      
      window.open(
        this.activeGame.serviceUrl,
        "_blank"
      );

    },

    // 关闭页面
    closePage() {
      onGoBack();
    },

    // 下拉刷新
    async onRefresh() {
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    }
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.vipPage {
  width: 100%;
  height: 100%;
  max-width: 375px;
  margin: auto;
  background: #f1f1f1;
  padding-top: 50px;
  padding-bottom: 80px;
  overflow: auto;
  &.hiddenTitle {
    padding-top: 0px;
    > header {
      display: none;
    }
  }
  .moreBtn{
    font-size: 12px;
    color: #999999;
    text-align: center;
    margin-bottom: 20px;
    >i{
      font-size: 12px;
      margin-left: 2px;
    }
  }
  > header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: 375px;
    margin: auto;
    z-index: 3;
    background: #ffffff;
    color: #000000;
    font-size: 19px;
    padding: 14px 5px 14px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      font-weight: bold;
      position: absolute;
    }
    > span {
      font-size: 18px;
      font-weight: 700;
      margin: 0 auto;
    }
    :global {
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }

  .gameBox {
    padding: 6px 0 0 0;
    height: 168px;
    position: relative;
    .gameListMask {
      background-size: cover;
      position: absolute;
      width: 100%;
      height: 168px;
      filter: blur(4px);
      top: 0;
    }
    .gameList {
      display: flex;
      width: 100%;
      height: 100px;
      overflow: scroll;
      align-items: baseline;
      .playing{
        width: 11.1px;
        position: absolute;
        left: 4px;
        top: 2px;
      }
      .activeGame {
        .img {
          width: 68px !important;
          height: 68px !important;
        }
        .gameTitle {
          font-size: 13px !important;
        }
      }
      .game {
        margin-left: 18px;
        z-index: 1;
        position: relative;
        .img {
          width: 58px;
          height: 58px;
        }
        .gameTitle {
          color: #ffffff;
          font-weight: 500;
          font-size: 12px;
          text-align: center;
          margin-top: 12px;
        }
      }
    }
  }
  .level {
    width: 360px;
    height: 124px;
    background: #ffffff;
    border-radius: 7px;
    box-shadow: -0.5px 0 7px 0.5px rgba(0, 0, 0, 0.03);
    margin: -36px auto 0;
    position: relative;
    z-index: 1;
    .titleBox{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .account{
        font-size: 11.11px;
        font-weight: 500;
        text-align: right;
        color: #9f9f9f;
        padding: 10px;

        img{
          width: 12px;
        }
      }
      
    }
    .title {
      font-size: 17px;
      font-weight: 700;
      text-align: left;
      color: #000000;
      padding: 10px;
    }
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .unBind {
        text-align: center;

        .desc {
          font-weight: 500;
          color: #7c7c7c;
          font-size: 14px;
          margin: 11px 0;
        }
        .bindAccountBtn {
          background: #ff9916;
          border-radius: 14px;
          width: 88px;
          height: 30px;
          font-size: 12px;
          font-weight: 500;
          text-align: center;
          color: #ffffff;
          line-height: 30px;
        }
      }
      .bind{
        width: 210px;
        margin-right: 40px;
        :global{
          .van-progress{
            border: 1px solid #ef4e5f;
            border-radius: 4.17px;
            .van-progress__pivot{
              display: none;
            }
          }
        }
        .desc{
          font-size: 14.58px;
          font-weight: 500;
          text-align: left;
          color: #7c7c7c;
          line-height: 13.19px;
          margin-bottom: 8px;
        }
        .money{
          font-size: 12.5px;
          font-weight: 400;
          text-align: left;
          color: #9f9f9f;
          line-height: 7.99px;
          margin-top: 11px;
          margin-bottom: 8px;
        }
        .tag{
          width: fit-content;
          background: #fc5f5e;
          border-radius: 6.25px 6.25px 6.25px 6.25px;
          font-size: 9.03px;
          font-weight: 400;
          color: #ffffff;
          padding: 1px 4px;
          margin-bottom: 8px;

        }
      }

      .vipBox {
        text-align: center;
        .vipImg {
          width: 64px;
          margin-bottom: 2px;
        }
        .showDesc {
          font-size: 12px;
          color: #1b97f7;
          display: block;
          text-decoration: underline;
        }
      }
    }
  }

  .gameGift {
    background: #ffffff;
    width: 100%;
    margin-top: 35px;
    .headerBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 42px;
      margin-bottom: 30px;
      > button {
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        font-size: 14px;
        width: 166px;
        height: 42px;
        border-radius: 20px;
        box-shadow: -4px 0px 6px 4px rgba(255, 201, 77, 0.36);
        margin-top: -40px;
      }
      .download {
        background: linear-gradient(0deg, #fcbb19 0%, #ffcc56 100%);
        margin-right: 10px;
      }
      .vipServer {
        background: linear-gradient(0deg, #fe9a66 0%, #feaa7c 100%);
      }
    }
    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      > p {
        font-size: 17px;
        font-weight: 700;
        text-align: center;
        color: #864e1d;
        margin: 0 8px;
      }
      > img {
        width: 64px;
      }
      .titleImg {
        transform: rotate(180deg);
      }
    }
    .rightContainer {
      display: flex;
      // align-items: center;
      // justify-content: space-evenly;
      margin-bottom: 20px;
      flex-flow: row wrap;
      align-content: flex-start;
      text-align: center;

      .right {
        text-align: center;
        flex: 0 0 16.4%;
        margin-bottom: 12px;
        .icon {
          width: 40px;
          height: 40px;
        }
        .text {
          font-size: 11px;
          font-weight: 400;
          text-align: center;
          color: #333333;
        }
      }
    }
    
    .tabHeader {
      font-size: 17px;
    }
    .tabContainer{
      min-height: 222px;
      .tabTitle{
        display: flex;
        margin-top: 5.21px;
        padding: 0 18.06px;
        align-items: center;
        >img{
          width: 58.33px;
          height: 58.33px;
          margin-right: 7.64px;
        }
        .name{
          font-weight: 500;
          text-align: center;
          color: #000000;
          font-size: 14.58px;
          line-height: 20px;
        }
        .total{
          font-size: 12.5px;
          font-weight: 400;
          text-align: left;
          color: #9f9f9f;
          line-height: 16px;
        }
        
      }
      .giftDetail{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 18px 15px 18px 18px ;
        .gray{
          filter: grayscale(1);
        }
        >button{
          width: 55.56px;
          height: 24.31px;
          line-height: 24.31px;
          background: linear-gradient(0deg,#fee8ba 0%, #f0cc8c 100%);
          border:none;
          border-radius: 12.15px;
          font-weight: 400;
          text-align: center;
          color: #512c19;
          font-size: 9.72px;
        }
        .name{
          // height: 13.81px;
          font-size: 12.5px;
          font-weight: 400;
          color: #111111;
          line-height: 22px;
          display: flex;
          align-items: center;
          >p{
            background: linear-gradient(-90deg,#fe635c 0%, #fe874d 100%);
            border-radius: 1.39px 6.94px 1.39px 6.94px;
            font-size: 9px;
            -webkit-transform: scale(0.85);
            font-weight: 400;
            color: #ffffff;
            line-height: 15px;
            // height: 14.93px;
            margin-left: -2px;
            padding: 0 5px;
          }
        }
        .detail{
          display: flex;
          align-items: baseline;
          width: 280px;
          >p{
            width: 279px;
          }
          -webkit-transform: scale(0.9);
          transform-origin: left;
          color: #8e662b;
          font-size: 11px;
          line-height: 13px;
          font-weight: 400;

          // }
        }
        .detail::before{
          content: "";
          border: 1.5px solid #8e662b;
          width: 3.4px;
          height: 3.4px;
          border-radius: 100%;
          margin-right: 2px;
          display: inline-block;
          // line-height: 12.83px;

        }
      }
      .activityDetail{
        width: 340.28px;
        height: 104.17px;
        border-radius: 6.94px;
        margin: 14px auto;
        position: relative;
        background-size: cover;
        .activityInfo{
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          top: 78px;
          .time{
            font-weight: 400;
            color: #ffffff;
            font-size: 9.72px;
            -webkit-transform: scale(0.88);
            width: 300px;
            margin-left: -12px;
          }
          >span{
            width: 70px;
            background: linear-gradient(0deg,#e1cc99 0%, #fff1c4 100%);
            border-radius: 9.38px;
            font-size: 8.33px;
            -webkit-transform: scale(0.85);
            font-weight: 700;
            color: #37230b;
            padding: 4px 8px;
            border: none;
            text-align: center;
          }
          .gray{
            filter: grayscale(1);
          }
        }
        .vipIcon{
          position: absolute;
          width: 25.35px;
          right: -4px;
          top: -10px;
        }
      }
    }
  }
  :global{
    .van-tabs--line{
      .van-tabs__wrap{
        height: 28px;
        .van-tab {
          line-height: 28px;
          font-size: 17px;
        }
      }
      .van-tabs__wrap::after{
        border: none !important;
      }
    } 

  }

  .dialogMask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 2;
  }
  .dialogContent {
    width: 300px;
    border-radius: 12px;
    overflow: hidden;
    background: #ffffff;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    margin: auto;
    padding-bottom: 21px;
    .close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 18px;
    }
    > h1 {
      width: 100%;
      height: 41px;
      text-align: center;
      background-color: #ffb017;
      color: #ffffff;
      font-size: 17px;
      font-weight: bold;
      // border-radius: 6px;
      line-height: 41px;
    }
    
    > .content {
      width: 225.69px;
      background: #f2f2f2;
      border-radius: 17.36px;
      display: flex;
      align-items: center;
      padding: 4px 15px;
      margin: 30px auto;
      margin-bottom: 8px;
      > p {
        color: #cdcdcd;
        font-size: 14px;
      }
      .field {
        border: none;
        padding: 0px 8px;
        background: transparent;
        width: 140px;
        height: 26px;
        :global {
          input {
            color: #7c7c7c;
          }
        }
      }
      :global {
        .yw-select-wrap {
          width: 100%;
          background-color: #e0e0e0;
          color: #888585;
        }
      }
    }
    .nextStep {
      margin: auto;
      width: 190px;
      height: 38px;
      line-height: 38px;
      border: none;
      border-radius: 38px;
      background: #ffb017;
      color: #ffffff;
      display: block;
      margin-top: 20px;
    }
    .giftDesc {
      font-size: 17.36px;
      font-weight: 700;
      text-align: center;
      color: #999999;
      width: 253.13px;
      margin: 29px auto 20px;
      line-height: 20px;
    }
    
    .giftCode {
      width: 151px;
      color: #999999;
      text-align: left;
      font-size: 13.19px;
      font-weight: 500;
      display: block;
      margin: auto;
      line-height: 20px;
      p:first-child{
        text-align: center;
        font-size: 15.97px;
      }
    }
    .giftBtn {
      width: 232.64px;
      height: 34.72px;
      background: #ffb017;
      border-radius: 17.36px;
      margin: 20px auto 0;
      font-size: 13.89px;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
      line-height: 12.5px;
      display: block;
    }


    .rule {
      color: #999999;
      font-size: 12px;
      text-align: left;
      padding: 10px;
      line-height: 16px;
    }
    :global{
      .van-swipe-item{
        padding:18px 0 0 12px ;
      }
    }
    .swipe{
      // padding: 18px 0 0 12px;

      >div{
        width: 265px;
        height: 210px;
        border: 1px solid #efdfd0;
        border-radius: 4px;
        overflow: auto;
      }

      .rightInfoTitle{
        font-size: 16.67px;
        color: #e7a664;
        text-align: center;
        padding: 9px 0 0;
      }
    }
    .indicator{
      text-align: center;
      color: #999999;
      font-size: 11.11px;
      margin-top: 19px;
    }
  }
}
</style>
